import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ProjectDetailsFieldsList } from '../projectdetails/List/ProjectDetailsFieldsList';
import { ProjectType, SetupAreaIdContext } from 'nekst-api';
import DetailsFieldsSetsContext from '../projectdetails/shared/DetailsFieldsSetsContext';
import { ProjectTypesTabs } from '../shared/ProjectTypesTabs/ProjectTypesTabs';
import useSettingsNavigator from '../settingsNavigator';
import { TeamSetupAreaContext } from './TeamSetupAreaContext';
import { MarketPageBreadcrumbs } from './MarketPageBreadcrumbs';
import { TeamSetupAreaInnerBlock } from './TeamSetupAreaInnerBlock';
import MarketActionsButton from './MarketActionsButton';


export default function MarketDetailBoxesPage() {
  const {
    setupAreaId: setupAreaIdString,
    projectType: projectTypeString
  } = useParams<{
    setupAreaId: string,
    projectType?: string
  }>();

  const setupAreaId = setupAreaIdString ?? '';
  const initialProjectType = projectTypeString ? projectTypeString.toUpperCase() as ProjectType : ProjectType.PENDING_BUYER;

  const [projectType, setProjectType] = React.useState<ProjectType>(initialProjectType);

  const settingsNavigator = useSettingsNavigator();

  useEffect(() => {
    settingsNavigator.openMarketDetailBoxesPage(setupAreaId!, projectType);
  }, [projectType]);

  return (
    <SetupAreaIdContext data={{
      setupAreaId
    }}>
      <TeamSetupAreaContext>
        <MarketPageBreadcrumbs />
        <DetailsFieldsSetsContext>
          <TeamSetupAreaInnerBlock
            projectType={projectType}
            headerRight={<MarketActionsButton />}
          >
            <ProjectTypesTabs
              setProjectType={setProjectType}
              projectType={projectType}
            />
            <ProjectDetailsFieldsList projectType={projectType} withParentField />
          </TeamSetupAreaInnerBlock>
        </DetailsFieldsSetsContext>
      </TeamSetupAreaContext>
    </SetupAreaIdContext>

  );

}
